import { type ProductCounters } from '@/domainLogic/index.ts';
import { SortValues } from '@/app/common/memsearch/types.ts';
import { APIStatusEnum } from '../../common/reloadData/APIStatusEnum';
import type { CityCard } from './cityCardTypes';

type DefaultSearch = {
  destination: string;
  dateFrom: string;
  dateTo: string;
  adults: string;
  sort: SortValues;
  origin: string;
};

export type ProductsResponse = {
  cityCards: CityCard[];
  productCounters: ProductCounters;
  searchId: string;
  message: string;
  status: APIStatusEnum;
  defaultSearch: DefaultSearch;
  businessProfileSearchResponse: string;
  rankingBusinessProfile: string;
  instantSearch: boolean;
};

export const productsResponseDefault: ProductsResponse = {
  cityCards: [],
  productCounters: {} as ProductCounters,
  status: APIStatusEnum.NORESULTS,
  searchId: '',
  message: '',
  defaultSearch: {
    destination: 'A',
    dateFrom: 'A',
    dateTo: 'T,2,3',
    adults: '2',
    sort: SortValues.Recommended,
    origin: 'LON',
  },
  businessProfileSearchResponse: '',
  rankingBusinessProfile: '',
  instantSearch: false,
};
